import React, { useState } from "react";
import { loadStripe, Stripe } from "@stripe/stripe-js";
import { Elements, useStripe, useElements, PaymentElement } from "@stripe/react-stripe-js";
import { StripeElementsOptions } from "@stripe/stripe-js";

// Load Stripe with your publishable key
const CheckoutForm: React.FC <{ payload: any,callAfterPayment:any}>= ({payload,callAfterPayment}) => {
          console.log(callAfterPayment)
          
          
  const stripe = useStripe();
  const elements = useElements();
  const [loading, setLoading] = useState<boolean>(false);
  const [isHovered, setIsHovered] = useState<boolean>(false); // Track hover state


  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    setLoading(true);

    if (!stripe || !elements) {
      console.error("Stripe has not loaded yet.");
      return;
    }

    // Create payment intent (fetch from backend)
//     const response = await fetch("http://localhost:5000/create-payment-intent", {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({ amount: payload?.amount }), // Example: 10 USD (amount is in cents)
//     });

//     const { clientSecret } = await response.json();

    // Confirm the card payment
//     @ts-ignore
// @ts-nocheck
    const result = await stripe.confirmPayment({elements,confirmParams: {
          // Return URL where the customer should be redirected after the PaymentIntent is confirmed.
          return_url: `${payload?.redirectUrl}/?kspay_id=${payload?.pe_txnId}&payment_status=Success&provider_payment_id=${''}`,
        },});

    console.log(result)

//     if (result.error) {
//       console.error(result.error.message);
//       const data={
//           status:false,
//           id:result?.error?.payment_intent?.id
//       }
//       callAfterPayment(data)
      
//     } else {
//       if (result.paymentIntent.status === "succeeded") {
//         const   data={
//                     status:true,
//                     id:result?.paymentIntent?.id
//                 }
//                 callAfterPayment(data)
// //         alert("Payment Successful!");
//       }
//     }

    setLoading(false);
  };

  return (
          <form onSubmit={handleSubmit} style={styles.form}>
      <h2 style={styles.title}>Complete Your Payment</h2>
      <div style={styles.cardInput}>
      <PaymentElement options={{layout: 'accordion'}}/>
      </div>
      <button
        type="submit"
        disabled={!stripe || loading}
        style={{
          ...styles.button,
          backgroundColor: isHovered ? "#5469d4" : "#6772e5",
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {loading ? "Processing..." : `Pay $${payload.amount}`}
      </button>
    </form>
  );
};

// Stripe Elements Wrapper Component
const StripeCheckout: React.FC <{ payload: any,callAfterPayment:any }>= ({payload,callAfterPayment}) => {
          const appearance: StripeElementsOptions = {
                    appearance: {
                      theme: "stripe", // ✅ Explicitly using a valid theme
                    },
                    clientSecret:payload?.clientSecret,
                    loader: 'always',
                  };
          const stripePromise: Promise<Stripe | null> = loadStripe(payload?.publishableKey);

 return  <Elements stripe={stripePromise} options={appearance}>
    <CheckoutForm payload={payload} callAfterPayment={callAfterPayment}/>
  </Elements>
}

export default StripeCheckout;


const styles: { [key: string]: React.CSSProperties } = {
          form: {
            maxWidth: "400px",
            margin: "50px auto",
            padding: "20px",
            border: "1px solid #ddd",
            borderRadius: "10px",
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
            textAlign: "center",
            backgroundColor: "#fff",
          },
          title: {
            fontSize: "22px",
            fontWeight: "bold",
            marginBottom: "20px",
          },
          cardInput: {
            padding: "10px",
            border: "1px solid #ccc",
            borderRadius: "5px",
            backgroundColor: "#f8f8f8",
            marginBottom: "20px",
          },
          cardElementBase: {
            fontSize: "16px",
            color: "#32325d",
          //   "::placeholder": { color: "#aab7c4" },
          },
          button: {
            width: "100%",
            padding: "10px",
            fontSize: "18px",
            fontWeight: "bold",
            color: "#fff",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
            transition: "background 0.3s ease",
          },
        };